import { createFileRoute } from '@tanstack/react-router';
import { ImpersonationLogsPage } from '@/pages/super-admin/impersonation/ImpersonationLogsPage';

export const Route = createFileRoute('/_authenticated/super-admin/impersonation-logs')({
	component: ImpersonationLogsPage,
});
